import { useState } from 'react';
import api from '../../utils/api';
import toast from 'react-hot-toast';

export default function Other({ member, shopId, onSaved }) {
  const [form, setForm] = useState({
    address1:   member?.address1   || '',
    address2:   member?.address2   || '',
    birth_date: member?.birth_date ? member.birth_date.split('T')[0] : '',
    married:    member?.married    || '',
    sex:        member?.sex        || '',
    religion:   member?.religion   || '',
    id_card_no: member?.id_card_no || '',
    other_name: member?.other_name || '',
  });
  const [saving, setSaving] = useState(false);
  const set = k => e => setForm(p => ({ ...p, [k]: e.target.value }));

  const save = async () => {
    setSaving(true);
    try {
      if (member?.id) {
        const { data } = await api.put(`/members/${member.id}`, form);
        onSaved(data);
      } else {
        const { data } = await api.post('/members', { shop_id: shopId, ...form });
        onSaved(data);
      }
      toast.success('Other info saved');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Save failed');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <div className="grid-2">
        <div className="form-group" style={{ gridColumn: '1 / -1' }}>
          <label className="form-label">Address 1</label>
          <textarea className="form-textarea" value={form.address1} onChange={set('address1')} rows={2} />
        </div>
        <div className="form-group" style={{ gridColumn: '1 / -1' }}>
          <label className="form-label">Address 2</label>
          <textarea className="form-textarea" value={form.address2} onChange={set('address2')} rows={2} />
        </div>
        <div className="form-group">
          <label className="form-label">Birth Date</label>
          <input className="form-input" type="date" value={form.birth_date} onChange={set('birth_date')} />
        </div>
        <div className="form-group">
          <label className="form-label">Marital Status</label>
          <select className="form-select" value={form.married} onChange={set('married')}>
            <option value="">— Select —</option>
            <option value="yes">Married</option>
            <option value="no">Single</option>
            <option value="widowed">Widowed</option>
            <option value="divorced">Divorced</option>
          </select>
        </div>
        <div className="form-group">
          <label className="form-label">Sex</label>
          <select className="form-select" value={form.sex} onChange={set('sex')}>
            <option value="">— Select —</option>
            <option value="male">Male</option>
            <option value="female">Female</option>
          </select>
        </div>
        <div className="form-group">
          <label className="form-label">Religion</label>
          <input className="form-input" value={form.religion} onChange={set('religion')} placeholder="Religion" />
        </div>
        <div className="form-group">
          <label className="form-label">ID Card No</label>
          <input className="form-input" value={form.id_card_no} onChange={set('id_card_no')} placeholder="NIC / ID Number" />
        </div>
        <div className="form-group">
          <label className="form-label">Other Name</label>
          <input className="form-input" value={form.other_name} onChange={set('other_name')} placeholder="Alias / Other name" />
        </div>
      </div>

      <div className="section-save-bar">
        <button className="btn btn-primary" onClick={save} disabled={saving}>
          {saving ? 'Saving…' : 'Save Other Info'}
        </button>
      </div>
    </div>
  );
}
